var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SyncFacebookPageModals',{ref:"syncFacebookPageModals",attrs:{"current-page-id":_vm.facebookPageId},on:{"syncExistingFacebookPage":_vm.handleSyncFacebookPage,"syncNewFacebookPage":_vm.handleSyncFacebookPage}})}
var staticRenderFns = []

export { render, staticRenderFns }